/**
 * 后台外壳插槽：锁屏遮罩由员工领域提供（spec-identity PG-X03，`apps/admin/src/components/lock-screen/**`，P0-12）。
 * 约定：`components/lock-screen/index.tsx` 默认导出 LockScreen 组件（props 见 LockScreenProps）；
 * 文件存在时 AdminLayout 在 ADMIN_SESSION_LOCKED 或会话 locked 时把它盖在页面上方（页面不卸载，已填数据保留）。
 */
import type { ComponentType } from 'react';

export interface LockScreenProps {
  /** 员工姓名（锁屏只显示姓名、密码 + 动态码、「解锁」、「退出登录」） */
  staffName: string;
  /** 解锁成功后调用（外壳重新拉取会话并撤下遮罩） */
  onUnlocked: () => void;
  /** 选择退出登录后调用 */
  onSignedOut: () => void;
}

const modules = import.meta.glob<{ default: ComponentType<LockScreenProps> }>('../lock-screen/index.tsx', { eager: true });

export const LockScreen: ComponentType<LockScreenProps> | null = Object.values(modules)[0]?.default ?? null;
